(function (module) {
    "use strict";

    module.component('tlButton', {
        template: require('./buttonComponent.html'),
        bindings: {
            text: "@",
            inProgressText: "@?",
            inProgress: "<",
            disabled: "<?",
            click: "&",
            icon: "<?",
            classNames: "@?"
        }
    });

}(angular.module('topline.components')));